export function numberToGimatria(number, withThousands = false, withGeresh = true) {
  const gimatria = {
    1: 'א',
    2: 'ב',
    3: 'ג',
    4: 'ד',
    5: 'ה',
    6: 'ו',
    7: 'ז',
    8: 'ח',
    9: 'ט',
    10: 'י',
    20: 'כ',
    30: 'ל',
    40: 'מ',
    50: 'נ',
    60: 'ס',
    70: 'ע',
    80: 'פ',
    90: 'צ',
    100: 'ק',
    200: 'ר',
    300: 'ש',
    400: 'ת',
    500: 'ך',
    600: 'ם',
    700: 'ן',
    800: 'ף',
    900: 'ץ'
  };

  if (number <= 0) {
    return '';
  }

  let str = '';
  let order = 0;
  let value = number;

  if (!withThousands) {
    value %= 1000;
  }

  while (value) {
    let current = (value % 10) * Math.pow(10, order++);
    let append = '';

    while (current > 400) {
      append += 'ת';
      current -= 400;
    }

    if (current) {
      append += gimatria[current];
    }

    str = append + str;
    value = Math.floor(value / 10);

    if (order === 3 && value) {
      str = `'${str}`;
      order = 0;
    }
  }

  str = str.replace('יה', 'טו').replace('יו', 'טז');

  if (withGeresh) {
    if (str.length >= 2) {
      str = `${str.slice(0, -1)}"${str.slice(-1)}`;
    } else {
      str += "'";
    }
  }

  return str;
}
